import 'simplelightbox/dist/simple-lightbox';

export default (el, {}, { cleanup }) => {
  const gallery = $(el).find('a.simplelightbox').simpleLightbox();

  cleanup(() => {
    gallery.destroy();
  });
};
